module.exports = __webpack_public_path__ + "img/energy1.430fa9c1.jpg";